import { Component, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {RequestPortabilidad} from './RequestPortabilidad'
import { PortabilidadService } from '../../services/portabilidad.service';
import { Observable, firstValueFrom } from 'rxjs';
import { LoginService } from '../../services/login.service';
import { tap, map } from 'rxjs/operators';
import { TokenService } from '../../services/token.service';
import { ModalService } from '../../core/services/modal.service';

@Component({
  selector: 'app-portabilidadweb',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './portabilidadweb.component.html',
  styleUrl: './portabilidadweb.component.scss'
})
export class PortabilidadwebComponent {

  @ViewChild('modalCustom') modalCustom!: TemplateRef<any>;

    form!: FormGroup;
    mostrarMensaje = false;

  constructor(private readonly modalService: ModalService, private readonly tokenService:TokenService, private readonly fb: FormBuilder,private readonly portabilidadService:PortabilidadService, private readonly loginService: LoginService) {
    this.form = this.fb.group({
      nombres: ['', Validators.required],
      apellidos: ['', Validators.required],
      rut: ['', Validators.required],
      telefono: ['', Validators.required],
      correo: ['', Validators.required],
      direccion: ['', Validators.required],
      comuna: ['', Validators.required],
      region: ['', Validators.required]
    });
  }

   async getToken(): Promise<any> {
  const data = await firstValueFrom(this.loginService.getSessionToken());

  console.log("TOKEN ", data);

  if (data) {
    this.tokenService.saveToken(data.token!);
    return data.token;
  }
}

  async startPortabilidad(request:RequestPortabilidad): Promise<void> {
    console.log("token");
     
    const token = await this.getToken()
    if (token)
    {
   await firstValueFrom(this.datosSolicitud(request)); 
    }

    }
 
    private datosSolicitud(request: any): Observable<void> {
  console.log("Solicitud de Certificado de Liquidación de Deuda");

  return this.portabilidadService.datosSolicitantes(request).pipe(
    tap(() => {
      console.log('Solicitud de Certificado de Liquidación de Deuda ejecutado');

      // abrir modal
      this.modalService.openModal(this.modalCustom);

      // esperar 5 segundos
      setTimeout(() => {
        this.modalService.closeModal();

        // redirigir
        window.location.href = 'https://www.unipay.cl';

      }, 5000);

    }),
    map(() => {})
  );
}
  

  enviar() {

    if (this.form.invalid) {
    this.form.markAllAsTouched(); // <--- Esto "despierta" a los validadores
    this.mostrarMensaje = true;
    console.log("Formulario inválido, campos faltantes:", this.form.errors);
    return;
  }

  this.mostrarMensaje = false;


  const formValue = this.form.value;

  const request = new RequestPortabilidad(
    formValue.nombres,
    formValue.apellidos,
    formValue.rut,
    formValue.telefono,
    formValue.correo,
    formValue.direccion,
    formValue.comuna,
    formValue.region
  );

  this.startPortabilidad(request);

}

}
